import { render, staticRenderFns } from "./confirmInput.vue?vue&type=template&id=2c70ebc4&"
import script from "./confirmInput.vue?vue&type=script&lang=js&"
export * from "./confirmInput.vue?vue&type=script&lang=js&"
import style0 from "./confirmInput.vue?vue&type=style&index=0&id=2c70ebc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports